export var HostType;
(function (HostType) {
    HostType["Classic"] = "editor";
    HostType["Editorx"] = "editor_x";
    HostType["Studio"] = "studio";
})(HostType || (HostType = {}));
//# sourceMappingURL=types.js.map